import $ from 'jquery';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import React, { Component } from 'react';
import { connect } from "react-redux";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../../actions/actions.jsx';
import service from '../../services/allservices.jsx';
import '../../stylesheet/faqs.css';
import Loader from '../loader/loader.jsx';
import { getClientId, getClientSecret,buildClientHeader } from '../../utils/clientAuth.js';


const mapStateToProps = state =>
({
    publicKey: state.publicKey.publicKey,
    keyRecieved: state.publicKey.keyRecieved,
    cardState: state.getCardReducer.cardState,
    display: state.getCardReducer.display
})

const mapDispatchToProps = dispatch =>
({
    fetchCard(state) {
        dispatch(
            actions.getCardAction(state)
        )
    },
    fetchPublicKey(keyRecieved) {
        dispatch(
            actions.publicKeyAction(keyRecieved)
        )
    },
})

class FAQS extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ViewQnA: [],
            toggleType: "password",
            toggleText: "password",
            toggleIcon: "fa fa-eye-slash",
            togglePassIcon: "fa fa-eye-slash",
            open: true,
            viewStatus: null,
            loader: true,
        }
    }
    async componentDidMount() {

        $('.panel-collapse').on('show.bs.collapse', function () {
            $(this).siblings('.panel-heading').addClass('active');
        });

        $('.panel-collapse').on('hide.bs.collapse', function () {
            $(this).siblings('.panel-heading').removeClass('active');
        });
        const JSEncrypt = window.JSEncrypt
        const { publicKey } = this.props
        if (publicKey.status === 200) {
            const public_Key = publicKey.body.publickey;
            let encrypt = new JSEncrypt();
            encrypt.setPublicKey(public_Key);

            const state = {
                applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                accountId: encrypt.encrypt(localStorage.getItem("accountId"))
            }
            this.props.fetchCard(state)
        }
        this.setState({
            selectedCard: this.props.cardState.body,
            // cardDetailsId:  this.props.cardState.body[0].cardDetailsId,
        }, () => {

            let _this = this

let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
                let traceId = getClientId();
                let gid = getClientId();
            // console.log("Program Name in Faq", _this.state.selectedCard[0].cardProgramId)
            fetch(plink + service.ViewFAQ + _this.state.selectedCard[0].cardProgramId, {
                headers: new Headers({
                    'Content-Type': 'application/json',
                     'X-Trace-Id': traceId,
                        'clientId': gid,
                        'clientSecret': getClientSecret(gid,this.state.selectedCard[0].cardProgramId),
                    'X-KlickEx-Client':buildClientHeader(),
                    // 'Authorization': `Token ${localStorage.getItem('token')}`,
                    // 'clientId': localStorage.getItem('clientId'),
                    // 'clientSecret': localStorage.getItem('secretId'),
                }),

            })
                .then(response => {
                    if (response.status === 200) {
                        let message = response.message ? response.message : response.headers.get('message')
                        toast.success( message , {
                            position: 'top-right',
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            draggablePercent: 60
                        })
                        response.json().then(json => {
                            this.setState({
                                ViewQnA: json,
                                viewStatus: 200,
                            })
                        })
                    }
                    else if (response.status === 422) {
                        toast.error(response.headers.get('message'), {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            draggablePercent: 60
                        })
                    }
                    else if (response.status === 401) {
                        if (this.props.history !== undefined) { this.props.history.push('/SessionOut') }
                    }
                    else {

                    }
                })
        })
    }
    componentWillReceiveProps(nextProps) {


        this.setState({
            loader: true
        })
        try {

            if (nextProps.cardState && nextProps.cardState.length !== 0) {
                this.setState({
                    loader: false,
                    selectedCard: nextProps.cardState.body[0],
                    value: nextProps.cardState.body[0].cardDetailsId,
                    cardDetailsId: nextProps.cardState.body[0].cardDetailsId,
                }, () => {




                })
            }
            else {

                this.setState({
                    loader: false
                })
            }
        } catch (e) {
        }
    }
    handleSelect1 = (event, index, value) => {
        this.setState({
            loader: true

        })
        const { cardState } = this.props

        // for (let i = 0; i < cardState.body.length; i++) {
        //     
        //     
        //     if (cardState.body[i].cardDetailsId === value) {
        //         this.setState({
        //             cardInUse: cardState.body[i],
        //             selectedCard: cardState.body[i],
        //             cardDetailsId: value,
        //             cardProgramIdNew: cardState.body[i].cardProgramId

        //         })
        //     }
        // }
        this.setState({
            cardDetailsId: value,

        })
        let value1 = cardState.body.filter(item => item.cardDetailsId === this.state.cardDetailsId)
        this.setState({   
            selectedvalue: value1,
            selectedCard: value1[0],
        }, () => {

let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
            let traceId = getClientId();
            let gid = getClientId();
            fetch(plink + service.ViewFAQ + this.state.selectedvalue[0].cardProgramId, {
                headers: new Headers({
                    'Content-Type': 'application/json',
                      'clientId': gid,
                    'clientSecret': getClientSecret(gid, this.state.selectedvalue[0].cardProgramId),
                     'X-Trace-Id': traceId,
                     'X-KlickEx-Client':buildClientHeader(),
                }),
            })
                .then(response => {
                    if (response.status === 200) {
                        let message = response.message ? response.message : response.headers.get('message')
                        response.json().then(json => {
                            this.setState({
                                ViewQnA: json,
                                loader: false
                            })

                        })
                        toast.success( message , {
                            position: 'top-right',
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            draggablePercent: 60
                        })
                        // setTimeout(function () {this.props.history.push('/faqmgmt') }, 3000)
                    }
                    else if (response.status === 422) {
                        this.setState({

                            loader: false
                        })
                        toast.error(response.headers.get('message'), {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            draggablePercent: 60
                        })
                    }
                    else if (response.status === 401) {
                        if (this.props.history !== undefined) { this.props.history.push('/SessionOut') }
                    } else {

                    }
                })
        })
    }
    pickIcon(eye) {
        this.setState({ eyeSelecionado: eye });
    }
    render() {
        const { ViewQnA, selectedCard, cardDetailsId } = this.state
        const { cardState } = this.props
        return (
            <div style={{}}>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                />
                <div className="col-sm-12 m-0 p-0">
                    <div className="row" style={{ }}>
                        <div className="header-style" style={{ padding: "5px 20px 0px 15px" }}>
                            <h4 className='logmainheading mainheading'>
                           FAQs
                            </h4>
                        </div>
                        {/* {cardState.status === 200 && cardState.body.length !== 0 && this.state.loader === false && ViewQnA ?
                            <div className="col-sm-12">
                                <div className="card-activity">
                                    <div className="col-md-12" style={{ padding: "0px 15px" }}>
                                        <div className="summary-header">
                                            <div className="row">
                                                <div className="col-sm-5" style={{ padding: "13px 0px 0px 0px" }}>{selectedCard && selectedCard.cardProgramId}</div>
                                                <div className="col-sm-7">
                                                    <div className="row">
                                                        <div className="col-sm-5 text-right" style={{ padding: "13px 13px" }}>
                                                            <p>Card Number</p>
                                                        </div>
                                                        <div className="col-sm-7">
                                                            <SelectField
                                                                floatingLabelText=""
                                                                onChange={this.handleSelect1}
                                                                className="input-width"
                                                                name="Selected Card"
                                                                autoComplete='none'
                                                                value={cardDetailsId}>
                                                                {cardState.body.map((value, i) =>
                                                                    <MenuItem value={cardState.body[i].cardDetailsId} primaryText={cardState.body[i].cardNumber} key={i} />
                                                                )}
                                                            </SelectField>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tile box-shadow-style" style={{ marginTop: "-12px" }}>
                                        <div className="row">
                                            <div className="col-md-6 col-sm-12">
                                                <div className="row">
                                                    <div className="col-md-6  tilepadding">
                                                        <label className="tilecontent">Card Number </label>
                                                    </div>
                                                    <div className="col-md-6 text-left tilepadding">
                                                        <span className="tileheadername">{selectedCard && selectedCard.cardNumber} </span><br />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6  tilepadding">
                                                        <label className="tilecontent">Name on Card </label>
                                                    </div>
                                                    <div className="col-md-6 text-left tilepadding">
                                                        <span className="tileheadername">{selectedCard && selectedCard.firstName + " " + selectedCard && selectedCard.lastName}  </span><br />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6  tilepadding">
                                                        <label className="tilecontent">Last Credit Posted </label>
                                                    </div>
                                                    <div className="col-md-6 text-left tilepadding">
                                                        <span className="tileheadername"> {selectedCard && selectedCard.lastCreditPosted}  </span><br />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-sm-12">
                                                <div className="row">
                                                    <div className="col-md-4  tilepadding">
                                                        <label className="tilecontent">Available Balance </label>
                                                    </div>
                                                    <div className="col-md-8 text-left tilepadding">
                                                        <span className="tileheadername"> {selectedCard && selectedCard.availableBalance}</span><br />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-4  tilepadding">
                                                        <label className="tilecontent">Ledger Balance </label>
                                                    </div>
                                                    <div className="col-md-8 text-left tilepadding">
                                                        <span className="tileheadername"> {selectedCard && selectedCard.ledgerBalance}</span><br />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-4  tilepadding">
                                                        <label className="tilecontent">Card Status </label>
                                                    </div>
                                                    <div className="col-md-8 text-left tilepadding">
                                                        <span className="tileheadername">{selectedCard && selectedCard.cardStatus}  </span><br />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                        <div className="col-sm-12 p-0 accordion animated zoomIn" id="accordionExample" style={{ background: "#fff" }}>
                            <div className="row">
                                <div className="col-sm-12 ">
                                    {ViewQnA &&
                                        ViewQnA.map((value, Index) =>
                                            <div className="col-sm-12">

                                                <div className="faq-questions " >
                                                    <div className="collapsed" data-toggle="collapse" data-target={`#collapseExample${Index + 1}`} aria-expanded="true" aria-controls="collapse">
                                                        <i className="fa fa-plus-circle faqswitch" style={{ float: "left", marginRight : "5px" ,  }} aria-hidden="true"></i>
                                                        {value.question}
                                                    </div>
                                                    
                                                </div>
                                                <div className="faq-answer collapse" id={`collapseExample${Index + 1}`} aria-labelledby="headingOne" data-parent="#accordionExample">
                                                    <div dangerouslySetInnerHTML={{ __html: value.answer }}></div>
                                                </div>
                                                <hr />
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* :   <div style={{ width: "100%" }}><Loader /></div>
                        } */}
                </div>
            </div>


        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FAQS);


// WEBPACK FOOTER //
// ./src/components/faqs/faqs.jsx